import React, { useEffect, useState } from 'react';
import { Box, Paper, Typography, Button, TextField, Switch, FormControlLabel, Select, MenuItem } from '@mui/material';

export default function AnalystPage() {
  const [stats, setStats] = useState({total_alerts:0, last_run:''});
  const [alerts, setAlerts] = useState([]);
  const [settings, setSettings] = useState({});
  const [aiModels, setAiModels] = useState({claude:[], openai:[]});
  const [msg, setMsg] = useState('');
  const tok = localStorage.getItem('dashboard_token');

  const load = () => {
    fetch('/api/analyst/stats', { headers:{Authorization:'Bearer '+tok} })
      .then(r=>r.json()).then(d=>setStats(d || {}));
    fetch('/api/analyst/alerts', { headers:{Authorization:'Bearer '+tok} })
      .then(r=>r.json()).then(d=>setAlerts(d || []));
    fetch('/api/analyst/settings', { headers:{Authorization:'Bearer '+tok} })
      .then(r=>r.json()).then(d=>setSettings(d || {}));
    fetch('/api/ai-models', { headers:{Authorization:'Bearer '+tok} })
      .then(r=>r.json()).then(d=>setAiModels(d || {claude:[], openai:[]}));
  };
  useEffect(() => { load(); const i = setInterval(load, 30000); return () => clearInterval(i); }, []);

  const updateSetting = async (key, value) => {
    await fetch('/api/analyst/settings/'+key, {
      method:'POST', headers:{Authorization:'Bearer '+tok, 'Content-Type':'application/json'},
      body: JSON.stringify({value: String(value)})
    });
    setMsg('💾 Збережено'); setTimeout(()=>setMsg(''),2000); load();
  };

  const runNow = async () => {
    setMsg('⏳ Запускаю аналіз...');
    await fetch('/api/analyst/run', { method:'POST', headers:{Authorization:'Bearer '+tok} });
    setMsg('✅ Виконано'); setTimeout(()=>setMsg(''),3000); load();
  };

  return (
    <Box sx={{p:3}}>
      <Typography variant="h5" sx={{color:'#FFD700',mb:3}}>📊 Аналітик метрик</Typography>

      <Paper sx={{bgcolor:'#1a1a2e',border:'1px solid #2196f3',p:3,mb:3}}>
        <Typography variant="h6" sx={{color:'#2196f3',mb:2}}>📈 Стан системи</Typography>
        <Box sx={{display:'flex',gap:3,flexWrap:'wrap',mb:2}}>
          <Box><Typography sx={{color:'#aaa',fontSize:13}}>Всього алертів</Typography><Typography sx={{color:'#f44336',fontSize:32,fontWeight:'bold'}}>{stats.total_alerts || 0}</Typography></Box>
          <Box><Typography sx={{color:'#aaa',fontSize:13}}>Останній запуск</Typography><Typography sx={{color:'#fff',fontSize:14,mt:1}}>{stats.last_run ? new Date(stats.last_run + 'Z').toLocaleString() : 'ніколи'}</Typography></Box>
        </Box>
        <Button variant="contained" onClick={runNow} sx={{bgcolor:'#2196f3'}}>▶ Запустити аналіз</Button>
      </Paper>

      <Paper sx={{bgcolor:'#1a1a2e',border:'1px solid #4caf50',p:3,mb:3}}>
        <Typography variant="h6" sx={{color:'#4caf50',mb:2}}>⚙️ Налаштування</Typography>
        <FormControlLabel control={<Switch checked={settings.analyst_enabled === 'true'} onChange={e=>updateSetting('analyst_enabled', e.target.checked ? 'true' : 'false')}/>}
          label={<Typography sx={{color:'#fff'}}>Увімкнути Аналітик</Typography>}/>
        <FormControlLabel control={<Switch checked={settings.analyst_notify_telegram === 'true'} onChange={e=>updateSetting('analyst_notify_telegram', e.target.checked ? 'true' : 'false')}/>}
          label={<Typography sx={{color:'#fff'}}>Сповіщення в Telegram</Typography>}/>
        <Box sx={{display:'flex',gap:2,mt:2,flexWrap:'wrap',alignItems:'center'}}>
          <TextField size="small" type="number" label="MAX_PERCENT" value={settings.analyst_max_percent || 25}
            onChange={e=>updateSetting('analyst_max_percent', e.target.value)}
            sx={{width:140,'& input':{color:'#fff'},'& label':{color:'#aaa'}}}/>
          <TextField size="small" type="number" label="Інтервал (хв)" value={settings.analyst_check_interval_min || 60}
            onChange={e=>updateSetting('analyst_check_interval_min', e.target.value)}
            sx={{width:140,'& input':{color:'#fff'},'& label':{color:'#aaa'}}}/>
          <Select size="small" value={settings.analyst_model || 'claude-haiku-4-5-20251001'}
            onChange={e=>updateSetting('analyst_model', e.target.value)}
            MenuProps={{PaperProps:{sx:{bgcolor:'#fff', maxHeight:400}}}}
            sx={{minWidth:240,color:'#fff'}}>
            <MenuItem disabled sx={{color:'#666',fontWeight:'bold'}}>🤖 Claude (Anthropic)</MenuItem>
            {aiModels.claude && aiModels.claude.map(m => (
              <MenuItem key={m.id} value={m.id} sx={{color:'#000',bgcolor:'#fff','&:hover':{bgcolor:'#FFD700'}}}>
                🤖 {m.name}
              </MenuItem>
            ))}
            <MenuItem disabled sx={{color:'#666',fontWeight:'bold'}}>🧠 OpenAI</MenuItem>
            {aiModels.openai && aiModels.openai.slice(0,15).map(m => (
              <MenuItem key={m.id} value={m.id} sx={{color:'#000',bgcolor:'#fff','&:hover':{bgcolor:'#FFD700'}}}>
                🧠 {m.name}
              </MenuItem>
            ))}
          </Select>
        </Box>
      </Paper>

      <Typography variant="h6" sx={{color:'#FFD700',mb:2}}>⚠️ Алерти ({alerts.length})</Typography>
      {alerts.length === 0 ? (
        <Paper sx={{bgcolor:'#1a1a2e',p:3,textAlign:'center',color:'#aaa'}}>Немає алертів</Paper>
      ) : alerts.map(a => (
        <Paper key={a.id} sx={{bgcolor:'#1a1a2e',border:'2px solid '+(a.severity === 'critical' ? '#f44' : a.severity === 'warning' ? '#ff9800' : '#4caf50'),p:2,mb:2}}>
          <Box sx={{display:'flex',justifyContent:'space-between',mb:1,flexWrap:'wrap'}}>
            <Box>
              <Typography sx={{color:'#FFD700',fontSize:15,fontWeight:'bold'}}>🔔 {a.alert_type}</Typography>
              <Typography sx={{color:'#aaa',fontSize:12}}>{a.metric_name}: {a.metric_value} (поріг {a.threshold})</Typography>
            </Box>
            <Typography sx={{color:'#aaa',fontSize:11}}>{new Date(a.created_at + 'Z').toLocaleString()}</Typography>
          </Box>
          <Typography sx={{color:'#fff',fontSize:13}}>{a.description}</Typography>
          {a.ai_recommendation && <Paper sx={{bgcolor:'#0a0a0a',p:1.5,mt:1,border:'1px solid #444'}}>
            <Typography sx={{color:'#4caf50',fontSize:12}}>🤖 {a.ai_recommendation}</Typography>
          </Paper>}
        </Paper>
      ))}

      {msg && <Typography sx={{color:'#4caf50',position:'fixed',bottom:20,right:20,bgcolor:'#1a1a2e',p:2,borderRadius:2,zIndex:9999}}>{msg}</Typography>}
    </Box>
  );
}
